import { i as o } from "./vendor-DWc995QB.mjs";
function t(i) {
  return !o(i);
}
export {
  t as i
};
//# sourceMappingURL=isNotNil-DCWUsql8.mjs.map
